import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { updateLocationTableHotkeys } from '../redux/actions'

const useLocationEditableCellHotkey = (locationId, fieldName) => {
  const dispatch = useDispatch()
  const {
    hotkeys: { selectedRowKey, selectedCellKey, isHotkeyEditModeEnabled },
  } = useSelector(store => store.locations.locations)

  const setHotkeyEditModeEnabled = useCallback(
    value =>
      dispatch(updateLocationTableHotkeys({ isHotkeyEditModeEnabled: value })),
    [dispatch],
  )

  return {
    isSelectInHotkeyEditMode:
      locationId === selectedRowKey &&
      selectedCellKey === fieldName &&
      isHotkeyEditModeEnabled,
    isFocusOnCell:
      locationId === selectedRowKey && selectedCellKey === fieldName,
    isFocusOnRow: locationId === selectedRowKey,
    isHotkeyEditModeEnabled,
    setHotkeyEditModeEnabled,
  }
}

export default useLocationEditableCellHotkey
